module.exports = __webpack_public_path__ + "img/01-anquan.5d6d1e8d.png";